import { FC } from 'react'
import { ScrollContainer } from 'components/DocRightRailV2/ScrollContainer/ScrollContainer'

interface Props {
  className?: string
}

const ScrollContent: FC<React.PropsWithChildren<Props>> = ({ children, className }) => {
  return <ScrollContainer className={className}>{children}</ScrollContainer>
}

export { ScrollContent }
